import { $api } from "../../../services/request.config";
import { getAllRequestsAndTypes } from "../getAllRequestsAndTypes.action";

import { element } from "prop-types";

export const getAllRequests = (props) => async(dispatch) => {
    try {
        props && props.setLoader &&  props.setLoader(true);

        const response = await $api("/v1.0/requests/types/all");
        if (response.status === 200) {
           const data =  response.data.map((element) => {
                let path = "";
                switch (element.type) {
                case 1:
                    path = "/main/hr-services/work-time/requests";
                    break;
                case 2:
                    path = "/main/hr-services/layoff/request";
                    break;
                    case 3:
                    path = "/main/hr-services/requests/leader";
                    const temp = element.types.map((el) => {
                        return {
                            ...el,
                            path: `/main/hr-services/requests/leader/${el.id}`,
                            title: el.name,
                        };
                    });
                    element.types = temp;
                    break;
                default:
                    path = "";
                    break;
                }
                return {
                    ...element,
                    path: path,
                };
            });
            console.log(data);
            dispatch(getAllRequestsAndTypes(data));
            props && props.setLoader &&  props.setLoader(false);

        }
        console.log(response.data);
    } catch (e) {
        props && props.setLoader &&  props.setLoader(false);
        dispatch(getAllRequestsAndTypes([]));
        console.log(e);
    }
};
